<template>
  <el-popover
    popper-class="el-popover--sidebar-icon"
    placement="right"
    trigger="hover"
    width="280">
    <template>
      <p class="el-popover__custom-title">{{ $t('label.navigation') }}</p>
      <el-collapse v-model="collapseActiveName" accordion>
        <template v-for="navigation in navigations">
          <el-collapse-item
             v-if="checkPageRequiredSubscribedFeature(navigation, SubscribedPlan)"
            :title="$t(navigation.label)"
            :name="navigation.url">
            <template v-if="navigation.type === 'section'">
              <nuttrema-menu-list theme="popover-nav" class="is-popover-collapse">
                <section>
                  <nuttrema-menu-list-item
                     v-for="(page, childIndex) in navigation.pages"
                     v-if="checkPageRequiredSubscribedFeature(page, SubscribedPlan)"
                    :key="page.url">
                    <router-link
                       tag="a"
                       class="list-item-link"
                       activeClass="is-active"
                      :exact="page.exact || false"
                      :to="{ path: page.url }">
                      <span class="text">{{ $t(page.label) }}</span>
                    </router-link>
                  </nuttrema-menu-list-item>
                </section>
              </nuttrema-menu-list>
            </template>
            <template v-else>
              <nuttrema-menu-list>
                <nuttrema-menu-list-item>
                  <router-link
                     tag="a"
                     activeClass="is-active"
                    :exact="navigation.exact || false"
                    :to="{ path: navigation.url }">
                    <span class="text">{{ $t(navigation.label) }}</span>
                  </router-link>
                </nuttrema-menu-list-item>
              </nuttrema-menu-list>
            </template>
          </el-collapse-item>
        </template>
      </el-collapse>
    </template>
    <nuttrema-iconica-sidebar-link
       slot="reference"
       icon="far fa-bars"
       theme="gray"
      @mouseenter="$emit('mouseenter')"
      @click="$emit('click')">
    </nuttrema-iconica-sidebar-link>
  </el-popover>
</template>

<script>
/* eslint-disable object-shorthand */
import { find, get } from 'lodash';
import { checkPageRequiredSubscribedFeature } from 'utils/check-permissions';

import SidebarMenu from 'components/ui/menu/sidebar-menu';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'sidebar-icon-level-zero',
  mixins: [SidebarMenu],
  components: {
    NuttremaIconicaSidebarLink,
  },
  computed: {
    InstanceSubscribedPlanSummarized() {
      return this.$store.getters.InstanceSubscribedPlanSummarized;
    },
    SubscribedPlan() {
      return get(this.InstanceSubscribedPlanSummarized, 'data.subscribed_plan');
    },
    collapseActiveName: {
      get: function () {
        const active = find(this.navigations, navigation => this.$route.path.startsWith(navigation.url));
        return active ? active.url : null;
      },
      set: function () {},
    },
  },
  methods: {
    checkPageRequiredSubscribedFeature,
  },
};
</script>

<style lang="scss">
  .el-popover.el-popover--sidebar-icon {
    padding: 6px 0 6px 0;

    .el-popover__custom-title {
      font-size: 1em;
      font-weight: 500;
      text-align: center;
      padding: 0.25em 12px 0.75em 12px;
      border-bottom: 1px solid #e6ebf5;
    }

    .el-collapse {
      border: none !important;
      .el-collapse-item {
        padding-right: 0;
        padding-left: 12px;

        .el-collapse-item__content {
          padding-bottom: 1em;
        }

        &.is-active {
          padding-right: 0;
          .el-collapse-item__content {
            padding-bottom: 0.5em;
          }
          .el-collapse-item__header {
            font-weight: 600;
          }
        }

        &:last-child {
          .el-collapse-item__header, .el-collapse-item__wrap {
            border-bottom: none !important;
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/menu/level-zero/sidebar-icon-level-zero.vue